<template>
    <div class="footnote">
        <div class="translate">
            <slot></slot>
        </div>
        <div>© 2017-2018 BC1131144 Inc. All rights reserved</div>
    </div>
</template>

<script>
export default {
  name: "footnote"
};
</script>

<style lang="less" scoped>
.footnote {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: #727272;
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/footnote/index.vue